export type DeathScreenCallbacks = {
  onRespawn: () => void;
};

export type DeathScreen = {
  show: (xpLost: number) => void;
  hide: () => void;
  get isVisible(): boolean;
  dispose: () => void;
};

export function createDeathScreen(callbacks: DeathScreenCallbacks): DeathScreen {
  let visible = false;

  const overlay = document.createElement("div");
  overlay.id = "death-screen";
  overlay.style.cssText = `
    position: fixed;
    inset: 0;
    background: rgba(180, 0, 0, 0.55);
    z-index: 200;
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-family: 'Segoe UI', system-ui, sans-serif;
    color: #fff;
    pointer-events: auto;
  `;

  const title = document.createElement("div");
  title.style.cssText = `
    font-size: 3.5rem;
    font-weight: 900;
    letter-spacing: 4px;
    text-shadow: 0 0 20px rgba(255,0,0,0.8), 0 2px 4px rgba(0,0,0,0.9);
    margin-bottom: 1rem;
    text-transform: uppercase;
  `;
  title.textContent = "VOCÊ MORREU";

  const xpText = document.createElement("div");
  xpText.style.cssText = `
    font-size: 1rem;
    color: #ffaaaa;
    margin-bottom: 2.5rem;
    text-shadow: 0 1px 3px rgba(0,0,0,0.9);
  `;

  const respawnBtn = document.createElement("button");
  respawnBtn.textContent = "Renascer";
  respawnBtn.style.cssText = `
    padding: 0.75rem 2.5rem;
    font-size: 1.1rem;
    font-weight: 700;
    background: rgba(255,255,255,0.15);
    border: 2px solid rgba(255,255,255,0.6);
    color: #fff;
    border-radius: 6px;
    cursor: pointer;
    letter-spacing: 1px;
    transition: background 0.15s;
  `;
  respawnBtn.addEventListener("mouseenter", () => {
    respawnBtn.style.background = "rgba(255,255,255,0.28)";
  });
  respawnBtn.addEventListener("mouseleave", () => {
    respawnBtn.style.background = "rgba(255,255,255,0.15)";
  });
  respawnBtn.addEventListener("click", () => callbacks.onRespawn());

  overlay.appendChild(title);
  overlay.appendChild(xpText);
  overlay.appendChild(respawnBtn);
  document.body.appendChild(overlay);

  function show(xpLost: number) {
    xpText.textContent = xpLost > 0
      ? `XP perdido neste nível: ${xpLost}`
      : "Nenhum XP perdido";
    overlay.style.display = "flex";
    visible = true;
  }

  function hide() {
    overlay.style.display = "none";
    visible = false;
  }

  function dispose() {
    respawnBtn.removeEventListener("click", () => callbacks.onRespawn());
    overlay.remove();
  }

  return {
    show,
    hide,
    get isVisible() { return visible; },
    dispose,
  };
}
